import { useState } from "react";
import Modal from "../reusable_components/Modal";
import { url } from "../utils/config";
import postData from "../custom_functions/postData";
import Input from "../reusable_components/Input";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import validateImageDimension from "../custom_functions/validateImageDimension";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";

function AddSpecialEquipment(props) {
        const [formData, setFormData ] = useState({})
        const [ image, setImage ] = useState();
        const [ imageUrl, setImageUrl ] = useState();
        const [ missingFields, setMissingFields ] = useState([]);
        const [ inputErrors, setInputErrors ] = useState([]);
        const [ showInputError, setShowInputError ] = useState(false);

        function updateFormData(e) {
            const { name, value, files } = e.target;
            const data = {...formData};
            data[name] = value;
            setFormData(data);
        }

        function addImage(e){
            const file = e.target.files[0];
            validateImageDimension(
                file, 
                () => {
                    toast.error('Image dimension should be between 256x256 and 720x720!', { autoClose: 3000 })
                },
                () => {
                    setImage(file);
                    setImageUrl(URL.createObjectURL(file));
                }
            );
            
        }

        function addEquipment() {
            console.log(image);

            const formdata = new FormData();
            formdata.append('image', image);
            Object.keys(formData).forEach(data => formdata.append(data, formData[data]))
            postData(`${url}/equipment`, formdata, (error) => {
                toast.error(error.response.data.message, { autoClose: 3000 });
                props.setShowForm(false)
            }, (data) => {
                toast.success(data.message, { autoClose: 3000 });
                props.setShowForm(false)
                props.reload(1 + Math.random())
            })
        }
        
        return(
            <div className={modalContainer}>
                <div className="bg-white w-2/5 px-8 pt-8 pb-4 rounded-lg">
                    <div className={modalTitle}>Add Special Equipment</div>
                    <div>
                        <div className="grid grid-cols-3">
                            <label className={label}>Equipment Name</label>
                            <div className="col-span-2">
                                <Input 
                                    index={0}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    name="name" 
                                    type='text' 
                                    maxLength='255'
                                    value={formData.name}
                                    required={true}
                                    className={inputStyle}
                                    placeHolder="Enter Equipment Name" 
                                    onChange={e => updateFormData(e)}
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-3 mt-2">
                            <label className={label}>Equipment Image</label>
                            <div className="col-span-2 text-center border border-blue-500 py-2 text-blue-500 rounded-lg text-sm cursor-pointer">
                                <label for='img-fl'>Upload Image</label>
                            </div>
                        </div>
                        <Input
                            index={0}
                            inputErrors={inputErrors}
                            setInputErrors={setInputErrors}
                            missingFields={missingFields}
                            id='img-fl'
                            name="image" 
                            type='file' 
                            value={formData.image}
                            className="hidden"  
                            required={true}
                            onChange={e => addImage(e)}
                        />
                        <div className="flex justify-between py-3 px-16 gap-8">
                            <button onClick={e => props.setShowForm(false)} className={btnCancel}>Cancel</button>
                            <Button clickHandler={e => addEquipment()} className={btnOne} name={'Submit'} />
                        </div>
                        <div className="text-red-500 font-semibold text-center">
                            {
                                showInputError && 'Please fill all the fields as directed!'
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    
}

export default AddSpecialEquipment;